import { IAddress } from "common/types";
import { Optional } from "common/utils/types";

import Address from "client/common/components/content/Address";
import SelectPanel from "client/common/components/inputs/SelectPanel";

import styles from "../styles/AddressSelectPanel.module.less";

type AddressSelectProps = {
  options: IAddress[];
  value: Optional<IAddress>;
  loadingValue?: Optional<IAddress>;
  disabled?: boolean;
  onClick: (value: IAddress) => void;
  onAdd: () => void;
};

const AddressSelectPanel = ({
  options,
  value,
  loadingValue,
  disabled,
  onClick,
  onAdd,
}: AddressSelectProps) => {
  return (
    <SelectPanel
      entityName="Address"
      getKey={(address) => (address && address.id) ?? ""}
      getState={(address) => ({ isLoading: loadingValue?.id === address.id, disabled })}
      options={options}
      renderOption={(address, { status }) => (
        <>
          <div className={styles.address}>
            <Address
              address={address}
              styles={{
                name: styles.name,
                address: styles.addressLine,
                street: styles.addressLine,
              }}
            />
          </div>
          {status}
        </>
      )}
      value={value}
      onClick={onClick}
      hasAdd={true}
      onAdd={onAdd}
      isAddDisabled={disabled}
    />
  );
};

export default AddressSelectPanel;
